<template>
    <div v-anchor>
        <div class="paperHeader">
            <Navigation :route="navigationRoute"></Navigation>
            <div class="paperHeaderTop mt-20">
                <div class="paperHeaderTop-title">
                    {{paperInfo.name}}
                </div>
                <div class="paperHeaderTop-c">
                    <div class="flex-btw mt-20">
                        <div>
                            <span class="paperHeaderTop-c-label">考试时间：</span>
                            {{paperInfo.startTime |dateFormat}}—{{paperInfo.endTime |dateFormat}}
                        </div>
                        <div>
                            <span class="paperHeaderTop-c-label">考试时间：</span>
                            {{paperInfo.duration||''}}分钟
                        </div>
                        <div>
                            <span class="paperHeaderTop-c-label">试卷总分：</span>
                            {{paperInfo.totalScore||''}}分
                        </div>
                        <div>
                            <span class="paperHeaderTop-c-label">及格分：</span>
                            {{paperInfo.passedScore||''}}分
                        </div>
                    </div>
                    <div class="flex mt-20">
                        <div>
                            <span class="paperHeaderTop-c-label">得分：</span>
                            {{paperInfo.score||0}}分
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="paper-con">
            <div class="paper-content">
                <div class="question-sections" v-for="(sec, secIndex) in paper.sections" :key="'s' + secIndex">
                    <div class="paperSecTitle">
                        {{ secIndex + 1 | toChinesNum }}、{{ quesMap[sec.trealType] }}（共{{ sec.tnum
                        }}小题，每题{{ sec.tscore }}分，共{{ sec.tscore * sec.tnum }}分）
                    </div>
                    <div v-for="(question, questionIndex) in sec.questions" :key="'q' + questionIndex"
                        class="page-question" :id="question.type + '_' + questionIndex">
                        <div class="question-item" :id="'IdDiv' + question.id">
                            <!-- <div class="question-title-item">
                                <div class="question-title"
                                    v-html="'【' + quesMap[question.type] + '】' + (questionIndex + 1) + '、' + deleteP(question.content)">
                                </div>
                            </div> -->

                            <div class="question-select mt-10"
                                v-if="question.type == 'SINGLECHOICE' || question.type == 'MULTIPLECHOICE' || question.type == 'JUDGMENT'">
                                <choice :info="question" :no="questionIndex"  :readOnly="readOnly"
                                    :check="checks[question.id]" v-model="answers['Q-'+question.id]"></choice>
                            </div>


                            <!-- 套题开始 -->
                            <div v-else-if="question.type == 'TT'" class=" mt-10">
                                <tt :info="question" :readOnly="readOnly" :lastNext="true" :submit="true"
                                    @input="change">
                                </tt>
                                <!-- <div v-for="(child, childIndex) in question.children" :key="childIndex"
                                    class="page-question">
                                    <div class="question-item">
                                       
                                        <div class="question-select mt-10"
                                            v-if="child.type == 'SINGLECHOICE' || child.type == 'MULTIPLECHOICE' || child.type == 'JUDGMENT'">
                                            <choice :info="child" :no="childIndex" @choose="change" :readOnly="readOnly"
                                                :check="checks[child.id]" v-model="answers[child.id]"></choice>
                                        </div>

                                        <div v-else>
                                            <div class=" mt-10" v-if="child.type == 'BLANKFILL'">
                                                <blank class="mt-10" :info="child" :no="childIndex" :readOnly="readOnly"
                                                    :check="checks[child.id]" v-model="answers[child.id]"></blank>
                                            </div>
                                            <div class="question-textarea mt-10" v-else>
                                                <essay :info="child" :no="childIndex" :readOnly="readOnly"
                                                    :check="checks[child.id]" v-model="answers[child.id]"></essay>
                                            </div>

                                        </div>
                                    </div>
                                </div> -->
                            </div>
                            <!-- 套题结束 -->

                            <div v-else>
                                <div class=" mt-10" v-if="question.type == 'BLANKFILL'">
                                    <blank class="mt-10" :info="question" :no="questionIndex" :readOnly="readOnly"
                                        :check="checks[question.id]" v-model="answers['Q-'+question.id]"></blank>
                                </div>
                                <div class="question-textarea mt-10" v-else>
                                    <essay :info="question" :no="questionIndex" :readOnly="readOnly"
                                        :check="checks[question.id]" v-model="answers['Q-'+question.id]"></essay>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="page-question-cardList">
                    <div class="page-answer-card-title">
                        主观题答题卡
                    </div>
                    <div class="page-answer-card-content">
                        <div class="card-image" v-for="(image,i) in cardList" :key="image.id">
                            <el-image
                                style="width: 100%;height: 100%;"
                                :src="image.url"
                                :preview-src-list="[image.url]">
                            </el-image>
                        </div>
                    </div>
                </div>

               
            </div>
            <!-- 答题卡 -->
            <div class="answerBox ml-15">
                
                <cardList :list="paper.sections" @submit="submit(1)" :answers="answers" v-if="paper.sections">
                </cardList>
            </div>
        </div>

    </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { getHistory } from "@/api/myTest.js";
import { mapState, mapMutations } from "vuex";
import choice from "@/components/question/choice.vue";
import blank from "@/components/question/blank.vue";
import essay from "@/components/question/essay.vue";
import cardList from "@/components/question/cardList.vue";
import tt from "@/components/question/tt.vue";
import examData from "./exam.json"
import { quesMap } from "@/utils/enum"
export default {
    name: "",
    components: {
        Navigation,
        choice,
        blank,
        essay,
        cardList,
        tt,

    },
    data() {
        return {
            navigationRoute: [
                { name: '我的测试' },
                { name: '我的考试' },
            ],
            readOnly: true,
            quesMap,
            title: '',
            shortestDeliverLeftTime: 0,
            answers: {
            },
            paper: {

            },
            cardList: [],
            paperId: '',
            url: '',
            timer: null,
            submitTimer: null,
            timerCountDown: null,
            paperInfo: {},
            imgList: [],
            countDownTime: 0,
            checks: {},
            dataId:''
        };
    },
    created() {
        this.paperId = this.$route.query.paperId
        this.dataId = this.$route.query.dataId
        this.start()
    },
    computed: {
    },
    methods: {
        start() {
            const that = this
            getHistory({ paperId: this.paperId,dataId: this.dataId }).then(res => {

            this.cardList = res.cardList
            this.answers = res.studentAnswer
            // 
            var paperData = res.paperContent
            paperData.sections.map(pv => {
                pv.questions.map(v => {
                    var reg = new RegExp('\\[BlankArea\\d]', 'g');
                    v.content = v.content.replace(reg, '____');
                    // 
                    // if (pv.trealType == 'BLANKFILL') {
                    //     if (that.answers['Q-' + v.id]) {
                    //         that.answers['Q-' + v.id] = that.answers['Q-' + v.id].split(',')
                    //     } else {
                    //         that.answers['Q-' + v.id] = []
                    //         v.blanks.map(b => {
                    //             that.answers['Q-' + v.id].push('')
                    //         })
                    //     }
                    // }
                })
            })
            this.paper = paperData

            this.shortestDeliverLeftTime = res.paperInfo.shortestDeliverLeftTime

            this.title = this.paper.name

            this.paperInfo = res.paperInfo
            let s = res.paperInfo.shortestSurplusTime

        })

        },
       
       
    },
};
</script>
<style lang="scss" scoped>
.paperHeader {
    background: #FFFFFF;
    padding: 20px;
    border-radius: 5px;

    .paperHeaderTop {
        .paperHeaderTop-title {
            text-align: center;
            font-weight: 500;
            font-size: 22px;
            color: #1A1A1A;
        }

        .paperHeaderTop-c {
            width: 80%;
            margin: auto;
            font-weight: 400;
            font-size: 14px;

            .paperHeaderTop-c-label {
                color: #767676;
            }
        }
    }

}

.paper-con {
    margin-top: 20px;

    .paper-content {
        flex:1;
        background: #FFFFFF;
        padding: 20px;
        border-radius: 5px;
    }

    display: flex;
}

.paperSecTitle {
    font-weight: 500;
    font-size: 14px;
    color: #1A1A1A;
}

.answerBox {
    width: 340px;
    min-width: 340px;
    box-sizing: border-box;
    border-radius: 5px;
    // min-height: 20%;
    // max-height: 80%;
    // height: 100%;
    background: #fff;
    // overflow-y: auto;
    overflow-y: hidden;
    position: sticky;
    top: 10px;
    height: 100%;

    .answerBox-date {
        font-weight: 400;
        font-size: 24px;
        color: #1A1A1A;
        padding: 15px;
        background: #FFF4E8;
    }
}
.page-answer-card-title{
    background-color: #e4e4e4;
    padding:10px;
}
.question-btn{
    text-align:center;
    margin-top:15px;
}
.page-answer-card-content{
    display: flex;
     justify-content: space-between; 
     flex-wrap: wrap;
}

    .card-image:nth-child(4n){ 
          margin-right: 0; 
        } 
        /* 使最后一个元素的边距填满剩余空间 */
        .card-image:last-child{ 
          margin-right: auto; 
        } 
.card-image{
    flex: 0 0 24%; 
          text-align:center;
          background-color: white;
          /* 边距懒得算，css函数代替 */ 
    margin:10px 0;
    margin-right: calc(4% / 3); 
          margin-bottom: calc(4% / 3); 
    position: relative;
    width: 150px;
    height: 150px;
    .delIcon{
        position: absolute;
        top: -8px;
    right: -8px;
    cursor: pointer;
    z-index:2;
    }
}
</style>